<template>

  <Teleport to="body">
    <dialog_CustomerView v-if="viewer_show" :customer="editingCustomer" :oth_viewCustomer="viewCustomer" :reloadForSync="fetchRecomList"/>
  </Teleport>

  
  <Teleport to="body">
    <dialog_giftshowDetail v-if="giftDetail_show" :goods_code="goods_code" :oth_viewDetail="viewDetail" />
  </Teleport>

  <Teleport to="body">
    <dialog_giftshowList v-if="giftList_show" :oth_viewList="viewGiftList" />
  </Teleport>

  <Teleport to="body">
    <dialog_rouletteShare 
      v-if="rouletteShare_show" 
      :oth_close="() => rouletteShare_show = false"
      :remainingTickets="remainingTickets"
      :onShared="fetchTickets"
    />
  </Teleport>

  <!-- 템플릿에 추가 -->
  <Teleport to="body">
    <dialog_ConsultWaitingEdit 
      v-if="showWaitingEdit" 
      :item="editingWaiting" 
      :onClose="() => showWaitingEdit = false"
      :onSaved="fetchWaitingList"
    />
  </Teleport>

  <div class="new_stack_p1_A">
    
    <div style="grid-column: 1 / 5; grid-row: 1 / 3;" class="box-shape">
      <div class="header" style="display:flex; align-items: center; justify-content: space-between; width:100%;"> <h2>👩‍🔧 추천 관리고객 &nbsp; <small> '보다AI'가 추천하는 이번 달 관리가 필요한 고객</small> </h2> <select> <option>최신순</option> <option>오래된순</option> </select> </div>
      <ul class="list-a">
        <li v-for="item in recomList" :key="`${item.idx}-${item.alert_type}`">
          <img :src="item.image || '/imgs/unknow_user.png'" @click="viewCustomer(true, item)" />
          <div class="recom-info" @click="viewCustomer(true, item)">
            <h3>'{{ item.name }}' {{ item.title }}</h3>
            <span class="alert-msg"><i :class="getAlertIcon(item.alert_type)" :style="{ color: getAlertColor(item.alert_type) }"></i> {{ item.alert_message }}</span>
          </div>
          <div class="quick-actions">
            <button 
              v-for="action in getQuickActions(item)" 
              :key="action.label"
              class="qa-btn"
              @click.stop="action.handler(item)"
            >
              <i :class="action.icon"></i> {{ action.label }}
            </button>
          </div>
          <button class="dismiss-btn" @click.stop="dismissRecom(item)"><i class="ph ph-x"></i></button>
        </li>
      </ul>
      <div class="pagination" v-if="recomTotalPages > 1">
        <button @click="goRecomPage(1)" :disabled="recomPage === 1">처음</button>
        <button @click="goRecomPage(recomPage - 1)" :disabled="recomPage === 1">&lt;</button>
        <button 
          v-for="p in recomTotalPages" 
          :key="p" 
          @click="goRecomPage(p)" 
          :class="{ active: recomPage === p }"
        >{{ p }}</button>
        <button @click="goRecomPage(recomPage + 1)" :disabled="recomPage === recomTotalPages">&gt;</button>
        <button @click="goRecomPage(recomTotalPages)" :disabled="recomPage === recomTotalPages">맨끝</button>
      </div>
    </div> 

    <div style="grid-column: 5 / 7; grid-row: 1 / 3;" class="box-shape">
      <div class="header" style="display:flex; justify-content: space-between; width:100%;">
        <h2>📞 상담 대기 고객</h2>
        <button class="add-btn" @click="openWaitingEdit(null)" v-if="member_info.level >= 1">+ 등록</button>
      </div>
      <ul class="list-b" v-if="waitingList.length > 0">
        <li v-for="item in waitingList" :key="item.idx">
          <img src="/imgs/unknow_user.png"/>
          <h2>{{ maskName(item.name) }}</h2>
          <span>{{ item.consult_type }}</span>
          <button 
            v-if="!item.picked_by" 
            class="pick-btn"
            @click.stop="pickCustomer(item.idx)"
          >찜</button>
          <button 
            v-else-if="item.picked_by === member_info?.mb_id" 
            class="pick-btn picked"
            @click.stop="unpickCustomer(item.idx)"
          >취소</button>
        </li>
      </ul>
      <div v-else class="empty-state">
        <p>대기 중인 상담이 없습니다</p>
      </div>
    </div>

    <div style="grid-column: 1 / 5; grid-row: 3 / 4;" class="box-shape shop-box">
      <div class="shop-header">
        <h3>🎁 선물하기</h3>
        <button class="more-btn" @click="viewGiftList(true)">더보기 →</button>
      </div>
      <ul class="list-shop">
        <li v-for="item in giftGoodsList.slice(0, 3)" :key="item.goodsCode" @click="viewDetail(true, item.goodsCode)">
          <img class="main-img" :src="item.goodsImgB" />
          <div class="info">
            <span class="name">{{ item.goodsName }}</span>
            <div class="brand"> <img :src="item.brandIconImg"> <span>{{item.brandName}}</span> </div>
            <p class="price">
              <strong>{{ formatMoney(item.discountPrice || item.realPrice) }}원</strong>
              <del v-if="item.discountPrice && item.discountPrice < item.realPrice">{{ formatMoney(item.realPrice) }}원</del>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div class="box-shape roulette">
      <div class="roulette-content" style="width:55% !important;">
        <div class="content-item">
          <img src="/imgs/common/roulette.png"  class="roulette-image" />
          <div style="position:absolute; left:0; top:0; width:100%; height:100%; display:flex; align-items:center; justify-content:center;">
            <img style="position:absolute; width:70%; height:auto; aspect-ratio: 1/1; object-fit:cover;" src="https://amadiary.com/pub/edit_icon/chara_moneybag.png">
          </div>
        </div>
      </div>
      <div class="bottom">
        <span>x{{remainingTickets}}</span>
        <button class="share-button" @click="rouletteShare_show = true" :disabled="remainingTickets < 1"><i class="ph ph-share-network"></i> 공유</button>
        <button class="start-button" @click="openLink('/event/roulette')"> <b>뽑기</b> 도전! </button>
      </div>
    </div>

    <div @click="makeCustomer()" style="grid-column: 1 / 2; grid-row: 4 / 5; cursor:pointer; background-color: #5286FF;" class="box-button">
      <i class="ph ph-user-plus"></i>
      <span >고객 등록</span>
      <small>금주 {{ newCusCnt }}명</small>
    </div>

    <div @click="showCustomerManageList(true)" style="grid-column: 2 / 3; grid-row: 4 / 5; cursor:pointer; background-color: #99ACFF;" class="box-button">
      <i class="ph ph-user-list"></i>
      <span>고객 리스트</span>
      <small>{{cusCnt}}명</small>
    </div>

    <div @click="showCrmList(true);" style="grid-column: 3 / 4; grid-row: 4 / 5; cursor:pointer; background-color: #FFA500;" class="box-button">
      <i class="ph ph-paper-plane-tilt"></i>
      <span>CRM</span>
      <small>발송{{ crmSuccessCnt }}/실패{{ crmFailedCnt }}</small>
    </div>

    <div @click="showInsuConsule(true)" style="grid-column: 4 / 5; grid-row: 4 / 5; cursor:pointer; background-color: #FFBF00;" class="box-button">
      <i class="ph ph-user-sound"></i>
      <span>고객상담</span>
      <small>최근 {{ historyCnt || 0 }}건</small>
    </div>

  </div>
</template>


<script>
import { inject, onMounted, onUnmounted, ref, computed } from 'vue';

import dialog_CustomerView from '@/components/dialogs/customerView.vue'
import dialog_ConsultWaitingEdit from '@/components/dialogs/consultWaitEdit.vue'
import dialog_giftshowDetail from '@/components/dialogs/giftshowDetail.vue'
import dialog_giftshowList from '@/components/dialogs/giftshowList.vue'
import dialog_rouletteShare from '@/components/dialogs/rouletteShareDialog.vue'

export default {
  props: {
    makeCustomer: {
      type: Function,
      required: true
    },
    showCustomerManageList: {
      type: Function,
      required: true
    },
    showInsuConsule: {
      type: Function,
      require: true
    },
    showCrmList: {
      type: Function,
      require: true
    }
  },
  components: {
    dialog_CustomerView,
    dialog_ConsultWaitingEdit,
    dialog_giftshowDetail,
    dialog_giftshowList,
    dialog_rouletteShare
  },
  setup() {
    const sql_query = inject('sql_query');
    const member_info = inject('member_info');
    const getGiftishowGoods = inject('getGiftishowGoods');

    const viewer_show = ref(false);
    const editingCustomer = ref(null);

    const goods_code = ref('');
    const giftDetail_show = ref(false);
    const giftList_show = ref(false);
    const rouletteShare_show = ref(false);

    const historyCnt = ref(0);

    async function fetchHistoryCnt() {
      if (!member_info?.mb_id) return;
      
      const sql = `
        SELECT COUNT(*) as cnt
        FROM insu_counsel_history
        WHERE mb_id = '${member_info.mb_id}'
      `;
      const res = await sql_query(sql);
      historyCnt.value = res?.[0]?.cnt || 0;
    }

    function viewDetail(b, code) {
      if (!b) {
        giftDetail_show.value = false;
        goods_code.value = '';
        return;
      } else {
        goods_code.value = code;
        giftDetail_show.value = true;
      }
    }

    function viewGiftList(b) {
      giftList_show.value = b;
    }

    // setup에 추가
    const showWaitingEdit = ref(false);
    const editingWaiting = ref(null);

    function openWaitingEdit(item) {
      editingWaiting.value = item;
      showWaitingEdit.value = true;
    }

    function viewCustomer(b, customer) {
      if (!b) {
        viewer_show.value = false;
        return;
      } else {
        editingCustomer.value = { ...customer };
        viewer_show.value = true;
      }
    }
    
    const cusCnt = ref(0);
    const newCusCnt = ref(0);
    const recomListAll = ref([]);
    const recomPage = ref(1);
    const recomPerPage = 5;
    
    const recomList = computed(() => {
      const start = (recomPage.value - 1) * recomPerPage;
      return recomListAll.value.slice(start, start + recomPerPage);
    });

    const recomTotalPages = computed(() => {
      return Math.max(1, Math.ceil(recomListAll.value.length / recomPerPage));
    });

    function goRecomPage(page) {
      if (page < 1 || page > recomTotalPages.value) return;
      recomPage.value = page;
    }

    const needHelpCus = ref(null);
    const waitingList = ref([]);

    const shopItems = [
      {name:'클리나 보온보냉 텀블러', img:'https://thumbnail.coupangcdn.com/thumbnails/remote/492x492ex/image/retail/images/615993834234350-52cb2102-d017-454b-acb4-bacad00902dd.jpg', price:'9,900', link:'https://www.coupang.com/vp/products/13180563' },
      {name:'데오라 차량용 방향제 1세트', img:'https://thumbnail.coupangcdn.com/thumbnails/remote/492x492ex/image/vendor_inventory/0de7/5166ef509faed78bb7114f31db81c34e0b9c338d912d60f3bf08f066e640.png', price:'7,900', link:'https://www.coupang.com/vp/products/8901935746' },
      {name:'양지다이어리 2026', img:'https://thumbnail.coupangcdn.com/thumbnails/remote/492x492ex/image/vendor_inventory/3843/f3920f1860301ec0b20d48ee45cbaa15d9f0992443eeda78ca407eb6979a.jpg', price:'6,680', link:'https://www.coupang.com/vp/products/9041970841' },
      {name:'모나미 볼펜 0.5mm 블랙 12개', img:'https://thumbnail.coupangcdn.com/thumbnails/remote/492x492ex/image/retail/images/2185551722734437-4120fc08-1f4c-43b9-af48-1d3da13e0219.jpg', price:'2,790', link:'https://www.coupang.com/vp/products/7512489876?itemId=3694470885' },
      {name:'1+1한정특가 6년근 홍삼정', img:'https://thumbnail.coupangcdn.com/thumbnails/remote/492x492ex/image/vendor_inventory/f858/26f569d737ba2abc2f7346254dfc2726c308c8c68ed99dcd2044ffd2399c.jpg', price:'54,800', link:'https://www.coupang.com/vp/products/8783323424' },
      {name:'닥스 세면 타월 4개 1세트', img:'https://thumbnail.coupangcdn.com/thumbnails/remote/492x492ex/image/retail/images/2832848209241027-00109a72-3555-481c-97f2-13695c539aa8.jpg', price:'23,900', link:'https://www.coupang.com/vp/products/7772041365' },
      {name:'스타벅스 겨울 3종 선물세트', img:'https://thumbnail.coupangcdn.com/thumbnails/remote/492x492ex/image/retail/images/2025/10/14/13/7/8d141a8c-c6ab-4474-89fa-7c9f898f1f39.png', price:'28,990', link:'https://www.coupang.com/vp/products/9124403494' },
      {name:'투썸플레이스 아메리카노 30개', img:'https://thumbnail.coupangcdn.com/thumbnails/remote/492x492ex/image/retail/images/2024/08/20/9/1/0dc7e115-0981-4db5-afb0-d46950d4dc9d.jpg', price:'21,600', link:'https://www.coupang.com/vp/products/8287305667' },
    ];

    const randomShopItems = computed(() => {
      return [...shopItems]
        .sort(() => Math.random() - 0.5)
        .slice(0, 8);
    });

    async function fetchThisWeekCustomers() {
      const sql = `
        SELECT COUNT(*) as cnt
        FROM customers
        WHERE YEARWEEK(created_at, 1) = YEARWEEK(NOW(), 1) and mb_id = '${member_info?.mb_id}'
      `;
      const res = await sql_query(sql);
      newCusCnt.value = res[0].cnt;
    }

    async function fetchCustomerCnt() {
      const sql = `
        SELECT COUNT(*) as cnt
        FROM customers
        WHERE mb_id = '${member_info?.mb_id}'
      `;
      const res = await sql_query(sql);
      cusCnt.value = res[0].cnt;
    }

    async function fetchRecomList() {
      // 1. 연락 안 한 고객
      const touchList = await sql_query(`
        SELECT c.*, 'touch' AS alert_type,
          CONCAT(DATEDIFF(NOW(), c.last_touch), '일째 연락 없음') AS alert_message
        FROM customers c
        WHERE c.mb_id = '${member_info?.mb_id}'
          AND DATEDIFF(NOW(), c.last_touch) >= 3
        ORDER BY last_touch ASC
        LIMIT 20
      `);
      
      // 2. 청구 후 팔로업
      const claimList = await sql_query(`
        SELECT c.*, 'claim' AS alert_type,
          CONCAT('보험청구 ', DATEDIFF(NOW(), ic.updated_at), '일 경과') AS alert_message
        FROM insu_claims ic
        JOIN customers c ON c.idx = ic.customer_idx
        WHERE ic.mb_id = '${member_info?.mb_id}'
          AND DATEDIFF(NOW(), ic.updated_at) <= 30
        ORDER BY ic.updated_at DESC
        LIMIT 20
      `);
      
      // 3. 생일 다가오는 고객
      const birthList = await sql_query(`
        SELECT c.*, 'birthday' AS alert_type,
          CONCAT(
            DATEDIFF(
              CONCAT(IF(DATE_FORMAT(c.birth,'%m%d') >= DATE_FORMAT(NOW(),'%m%d'), YEAR(NOW()), YEAR(NOW())+1), '-', DATE_FORMAT(c.birth,'%m-%d')),
              CURDATE()
            ), '일 후 생일입니다'
          ) AS alert_message
        FROM customers c
        WHERE c.mb_id = '${member_info?.mb_id}'
          AND c.birth IS NOT NULL AND c.birth != ''
        ORDER BY DATE_FORMAT(c.birth,'%m%d') ASC
        LIMIT 20
      `);
      
      recomListAll.value = [...touchList, ...claimList, ...birthList];
      recomPage.value = 1;
    }

    function getAlertIcon(type) {
      const icons = {
        'touch': 'ph-fill ph-hand-waving',
        'claim': 'ph-fill ph-file-text',
        'birthday': 'ph-fill ph-cake',
        'recent': 'ph-fill ph-star',
      };
      return icons[type] || 'ph-fill ph-bell';
    }

    function getAlertColor(type) {
      const colors = {
        'touch': '#f59e0b',
        'claim': '#ef4444',
        'birthday': '#ec4899',
        'recent': '#3b82f6',
      };
      return colors[type] || '#6b7280';
    }

    function getQuickActions(item) {
      const type = item.alert_type;
      const map = {
        'touch': [
          { icon: 'ph ph-phone', label: '안부 전화', handler: (i) => quickCall(i) },
          { icon: 'ph ph-calendar-plus', label: '일정 등록', handler: (i) => viewCustomer(true, i) },
        ],
        'claim': [
          { icon: 'ph ph-file-magnifying-glass', label: '청구 확인', handler: (i) => viewCustomer(true, i) },
          { icon: 'ph ph-phone', label: '바로 연락', handler: (i) => quickCall(i) },
        ],
        'birthday': [
          { icon: 'ph ph-chat-text', label: '축하 연락', handler: (i) => quickCall(i) },
          { icon: 'ph ph-gift', label: '선물하기', handler: () => viewGiftList(true) },
        ],
        'recent': [
          { icon: 'ph ph-shield-check', label: '보장분석', handler: (i) => viewCustomer(true, i) },
          { icon: 'ph ph-phone', label: '바로 연락', handler: (i) => quickCall(i) },
        ],
      };
      return map[type] || [
        { icon: 'ph ph-phone', label: '연락하기', handler: (i) => quickCall(i) },
      ];
    }

    function quickCall(item) {
      if (item.phone) {
        window.location.href = `tel:${item.phone}`;
      } else {
        viewCustomer(true, item);
      }
    }

    function dismissRecom(item) {
      recomListAll.value = recomListAll.value.filter(
        r => !(r.idx === item.idx && r.alert_type === item.alert_type)
      );
    }

    // 상담 대기 목록
    async function fetchWaitingList() {
      const sql = `
        SELECT * FROM consult_waiting 
        WHERE status IN (0, 1)
          AND (picked_by IS NULL OR picked_by = '${member_info?.mb_id}')
        ORDER BY 
          CASE WHEN picked_by = '${member_info?.mb_id}' THEN 0 ELSE 1 END,
          created_at ASC
        LIMIT 5
      `;
      const res = await sql_query(sql);
      waitingList.value = res || [];
    }

    // 이름 마스킹 (김우인 → 김*인)
    function maskName(name) {
      if (!name || name.length < 2) return name;
      if (name.length === 2) return name[0] + '*';
      return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
    }

    // 찜하기
    async function pickCustomer(idx) {
      await sql_query(`
        UPDATE consult_waiting 
        SET picked_by = '${member_info?.mb_id}', picked_at = NOW(), status = 1
        WHERE idx = ${idx} AND picked_by IS NULL
      `);
      fetchWaitingList();
    }

    // 찜 해제
    async function unpickCustomer(idx) {
      await sql_query(`
        UPDATE consult_waiting 
        SET picked_by = NULL, picked_at = NULL, status = 0
        WHERE idx = ${idx} AND picked_by = '${member_info?.mb_id}'
      `);
      fetchWaitingList();
    }

    function openLink(link) {
      window.open(link);
    }

    function handleCustomerUpdated() {
      fetchCustomerCnt();
      fetchThisWeekCustomers();
      fetchRecomList();
    }

    onMounted(() => {
      fetchCustomerCnt();
      fetchThisWeekCustomers();
      fetchRecomList();
      fetchWaitingList();
      fetchHistoryCnt();
      fetchCrmStats();
      window.addEventListener('customer-updated', handleCustomerUpdated);
    });

    onUnmounted(() => {
      window.removeEventListener('customer-updated', handleCustomerUpdated);
    });

    
    const giftGoodsList = ref([]);

    onMounted(() => {
      getGiftishowGoods().then(res => {
        giftGoodsList.value = res?.result?.goodsList || [];
      });
    });

    function formatMoney(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    // CRM 발송 통계
    const crmSuccessCnt = ref(0);
    const crmFailedCnt = ref(0);

    async function fetchCrmStats() {
      const sql = `
        SELECT 
          SUM(CASE WHEN status = 'success' THEN 1 ELSE 0 END) as success_cnt,
          SUM(CASE WHEN status = 'failed' THEN 1 ELSE 0 END) as failed_cnt
        FROM crm_send_logs
        WHERE mb_id = '${member_info.mb_id}'
      `;
      const res = await sql_query(sql);
      crmSuccessCnt.value = res?.[0]?.success_cnt || 0;
      crmFailedCnt.value = res?.[0]?.failed_cnt || 0;
    }

    const remainingTickets = ref(0);
    async function fetchTickets() {

      // 스핀권 조회
      const ticketQuery = `
        SELECT SUM(ticket_count - used_count) as remaining
        FROM roulette_tickets 
        WHERE mb_id = '${member_info.mb_id}' 
        AND status = 'active' 
        AND (expired_at IS NULL OR expired_at > NOW())
        AND ticket_count > used_count
      `;
      
      const tickets = await sql_query(ticketQuery);
      
      if (tickets?.[0]?.remaining) {
        remainingTickets.value = parseInt(tickets[0].remaining) || 0;
      }
    }
    fetchTickets();


    return {
      recomList,
      recomPage,
      recomTotalPages,
      goRecomPage,
      needHelpCus,
      newCusCnt,
      cusCnt,
      shopItems,
      openLink,
      randomShopItems,
      fetchRecomList,
      viewCustomer,
      editingCustomer,
      viewer_show,
      getAlertIcon,
      getAlertColor,
      getQuickActions,
      quickCall,
      dismissRecom,
      waitingList,
      fetchWaitingList,
      maskName,
      pickCustomer,
      unpickCustomer,
      member_info,
      showWaitingEdit,
      editingWaiting,
      openWaitingEdit,
      giftGoodsList,
      formatMoney,
      viewDetail,
      giftDetail_show,
      goods_code,
      historyCnt,
      crmSuccessCnt,
      crmFailedCnt,
      remainingTickets,
      giftList_show,
      viewGiftList,
      rouletteShare_show,
      fetchTickets
    }
  }
}

</script>


<style scoped>
  input:focus {
    outline: none;
    border: 2px solid var(--color-brand);
  }

  #consered {
    opacity: 0.6;
    filter: blur(1px);
  }

  .new_stack_p1_A {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(4, 1fr);
    gap: var(--grid-gap);
    width:100%;
    height:100%;
    flex:1;
    color:#fff;
  }
  .new_stack_p1_A {
    --grid-gap: 24px;
  }

  @media (max-width: 1024px) {
    .new_stack_p1_A {
      --grid-gap: 12px;
    }
  }

  .box-shape {
    background:rgba(0,0,0,0.4);
    border-radius: 16px;
    backdrop-filter: blur(12px);
    padding:16px;
    display:flex; gap:16px; align-items: center; justify-content: start; flex-direction: column;
    overflow:hidden;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    transform: scale(0.98);
    transition: all 0.2s ease-in-out;
  }

  .box-shape.roulette {
    grid-column: 5 / 7; grid-row: 3 / 5; background-image: url('~@/../public/imgs/common/roulette_bg2.png'); background-position: center center; background-size: cover; padding-top:20%;
  }
  .box-shape:hover {
    transform: scale(1);
  }

  .box-button {
    position:relative;
    background:var(--color-brand);
    border-radius: 16px;
    padding:16px;
    display:flex; gap:var(--font-size-sm); align-items: center; justify-content: center; flex-direction: column;
    cursor:pointer;
    transform: scale(0.9);
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  }

  .box-button:hover {
    transform: scale(1);
  }

  .box-button > i {
    font-size:var(--font-size-4xl);
  }

  .box-button > span {
    font-size:var(--font-size-lg);
  }

  .box-button > small {
    font-size:var(--font-size-base);
  }

  .box-shape.widget-btn {
    display:flex;
    align-items: center;
    justify-content: center;
    cursor:pointer;
    gap:6px;
    font-size:16px;
    font-weight:500;
    color:#fff;
  }

  .header-roulette {
    display:flex;
    justify-content: center;
    align-items: center;
    width:100%;
    flex-direction: column;
    gap:6px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #2D3E7E 0%, #4A5FA5 100%);
    border-radius: 16px;
    padding: 6px;
    text-align: center;
    box-shadow: 0 8px 24px rgba(45, 62, 126, 0.3);
    border: 2px solid #FFD93D;
  }

  .header-roulette > h2 {
    font-size:var(--font-size-xl);
    color:#ffcd18;
    padding:0;
    margin:0;
    font-weight: 800;
  }

  .header-roulette > span {
    font-size:var(--font-size-md);
    color:#ffc851;
    padding:0;
    margin:0;
    font-weight: 400;
  }

  .header-roulette strong {
    color: #FF6B9D !important;
  }

  .roulette-content {
    width:100%; height:100%; border-radius: 16px; display:flex; align-items: center; justify-content: center; gap:16px; color:#fff;
  }

  .roulette-content > .content-item {
    position:relative;width:100%;height:100%;flex:1; display:flex; align-items: center; justify-content: center; flex-direction: column; gap:12px;
  }

  .roulette-content > .content-item > img {
    width:100%;
    height:auto;
    aspect-ratio: 1/1 auto;
    border-radius: 50%;
    object-fit: cover;
    background: gray;
    filter: drop-shadow(2px 2px 6px rgba(0,0,0,.4));
  }

  .roulette-image {
    transition: transform 0.6s ease-out;
    cursor: pointer;
  }

  @keyframes roulette-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .roulette-content > .content-item > span {
    font-size:14px;
    padding:0;
    margin:0;
  }

  .roulette-content > .content-item > h2 {
    width:100%;
    text-align: center;
    font-size:20px;
    padding:0;
    margin:0;
  }

  .roulette-content > .content-item > ul {
    width:100%;
    height:100%;
    padding:0;
    list-style: none;
    display:flex;
    flex-direction: column;
    gap:12px;
  }

  .roulette-content > .content-item > ul > li {
    width:100%;
    height:fit-content;
    display:flex;
    align-items: center;
    justify-content: center;
    gap:12px;
  }

  .roulette-content > .content-item > ul > li > span {
    font-size:14px;
    padding:0;
    margin:0;
    font-weight: 400;
  }

  .roulette > .bottom {
    width:100%;
    height:36px;
    display:flex;
    align-items:center;
    gap:12px;
  }

  .roulette > .bottom > span {
    width:fit-content;
    height:100%;
    flex:1;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:14px;
    background:#fff;
    border-radius:50px;
    color:#000;
  }

  .start-button {
    flex:3;
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 50px;
    font-size:16px;
    font-weight:600;
    background:#000;
    color:#fff;
    cursor: pointer;
    transition: all 0.2s;
  }

  .start-button > b {
    color:var(--color-brand);
  }

  .share-button {
    flex:2;
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 50px;
    font-size:14px;
    font-weight:600;
    background: rgba(255,255,255,0.9);
    color:#333;
    cursor: pointer;
    transition: all 0.2s;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:4px;
  }

  .share-button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .share-button:not(:disabled):hover {
    background:#fff;
    transform: scale(1.02);
  }

  .button-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: white;
    font-size: 20px;
    font-weight: 900;
    text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.2);
  }

  .button-content i {
    font-size: 28px;
  }

  .header { 
    display:flex;
    justify-content: start;
    align-items: start;
    width:100%;
  }

  .header > h2 {
    font-size:20px;
    padding:0;
    margin:0;
  }

  .header > select {
    font-size:14px;
    padding:6px;
    border-radius: 6px;
    border:none;
    background:transparent;
    color:#fff;
  }

  ul.list-a {
    width:100%;
    height:100%;
    flex: 1;
    overflow-y: auto;
    list-style: none;
    padding:0px;
    margin:0;
    display:flex;
    flex-direction: column;
    gap:12px;

    scrollbar-width: thin;
    scrollbar-color: rgba(150,150,150,0.3) transparent;
  }

  ul.list-a::-webkit-scrollbar {
    width: 5px;
  }

  ul.list-a::-webkit-scrollbar-track {
    background: transparent;
  }

  ul.list-a::-webkit-scrollbar-thumb {
    background: rgba(150,150,150,0.3);
    border-radius: 10px;
  }

  ul.list-a::-webkit-scrollbar-thumb:hover {
    background: rgba(150,150,150,0.5);
  }

  ul.list-a > li {
    width:100%;
    display:flex;
    gap:10px;
    align-items: center;
    padding:10px 12px;
    box-sizing: border-box;
    background:rgba(255,255,255,0.06);
    border-radius: 10px;
    transition: all 0.2s;
  }

  ul.list-a > li:hover {
    background:rgba(255,255,255,0.12);
    transform: translateY(-1px);
  }

  ul.list-a > li > img {
    width:40px;
    height:40px;
    border-radius: 50%;
    object-fit: cover;
    background: gray;
    cursor:pointer;
    flex-shrink:0;
  }

  .recom-info {
    flex:1;
    display:flex;
    flex-direction:column;
    gap:3px;
    min-width:0;
    cursor:pointer;
  }

  .recom-info > h3 {
    margin:0;
    padding:0;
    font-size:15px;
    font-weight:600;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }

  .alert-msg {
    font-size:12px;
    color:rgba(255,255,255,0.55);
    display:flex;
    align-items:center;
    gap:5px;
  }

  .alert-msg > i {
    font-size:14px;
  }

  .quick-actions {
    display:flex;
    gap:6px;
    flex-shrink:0;
  }

  .qa-btn {
    display:flex;
    align-items:center;
    gap:4px;
    padding:6px 12px;
    border:none;
    border-radius:8px;
    background:rgba(255,255,255,0.1);
    color:rgba(255,255,255,0.85);
    font-size:12px;
    font-weight:500;
    cursor:pointer;
    transition: all 0.15s;
    white-space:nowrap;
  }

  .qa-btn:hover {
    background:rgba(255,255,255,0.2);
    color:#fff;
    transform:scale(1.03);
  }

  .qa-btn > i {
    font-size:14px;
  }

  .dismiss-btn {
    width:28px;
    height:28px;
    border:none;
    background:none;
    color:rgba(255,255,255,0.25);
    cursor:pointer;
    font-size:16px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:50%;
    transition:all 0.15s;
    flex-shrink:0;
  }

  .dismiss-btn:hover {
    color:#fff;
    background:rgba(255,255,255,0.1);
  }

  ul.list-b {
    width:100%;
    height:100%;
    flex: 1;
    overflow-y: auto;
    list-style: none;
    padding:0px;
    margin:0;
    display:flex;
    flex-direction: column;
    gap:12px;

    scrollbar-width: thin;
    scrollbar-color: rgba(150,150,150,0.3) transparent;
  }

  ul.list-b::-webkit-scrollbar {
    width: 5px;
  }

  ul.list-b::-webkit-scrollbar-track {
    background: transparent;
  }

  ul.list-b::-webkit-scrollbar-thumb {
    background: rgba(150,150,150,0.3);
    border-radius: 10px;
  }

  ul.list-b::-webkit-scrollbar-thumb:hover {
    background: rgba(150,150,150,0.5);
  }

  ul.list-b > li {
    width:100%;
    height:fit-content;
    display:flex;
    gap:6px;
    align-items: center;
    cursor:pointer;
    border-radius: 6px;
    transition: all 0.2s;
  }

  ul.list-b > li:hover {
    transform: translateY(-2px);
  }

  ul.list-b > li > img {
    width:var(--font-size-2xl);
    height:var(--font-size-2xl);
    border-radius: 50%;
    object-fit: cover;
    background: gray;
  }

  ul.list-b > li > h2 {
    padding:0;
    margin:0;
    font-size:16px;
    flex:1;
  }

  ul.list-b > li > span {
    font-size:14px;
  }

  /* Shop Header */
  .shop-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .shop-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
  }

  .more-btn {
    background: none;
    border: none;
    color:#fff;
    font-size: 13px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background 0.2s;
  }

  .more-btn:hover {
    background: var(--color-background);
  }

  /* Shop List - 가로 스크롤 */
  ul.list-shop {
    width: 100%;
    display: flex;
    gap: 16px;
    list-style: none;
    padding: 0;
    margin: 0;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
  }

  ul.list-shop::-webkit-scrollbar {
    display: none;
  }

  ul.list-shop > li {
    flex: 1;
    width:100%;
    height:100%;
    display: flex;
    gap: 8px;
    cursor: pointer;
    scroll-snap-align: start;
    transition: transform 0.2s;
  }

  ul.list-shop > li:hover {
    transform: translateY(-2px);
  }

  ul.list-shop > li .img-wrap {
    position: relative;
    height:100%;
  }

  ul.list-shop > li .main-img {
    height:100%;
    width:auto;
    aspect-ratio: 1/1 auto;
    border-radius: 16px;
    object-fit: contain;
    background: #f5f5f5;
  }

  ul.list-shop > li .brand img {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    object-fit: cover;
    background: #fff;
    box-shadow: 0 3px 3px rgba(0,0,0,0.15);
  }

  ul.list-shop > li .brand {
    display:flex;
    align-items:center;
    font-size:14px;
    gap:6px;
  }

  ul.list-shop > li .info {
    display: flex;
    flex:1;
    flex-direction: column;
    gap: 4px;
  }

  ul.list-shop > li .name {
    font-size: 13px;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: var(--color-text);
  }

  ul.list-shop > li .price {
    margin: 0;
    display: flex;
    align-items: baseline;
    gap: 4px;
    flex-wrap: wrap;
  }

  ul.list-shop > li .price strong {
    font-size: 14px;
    color: var(--color-text);
  }

  ul.list-shop > li .price del {
    font-size: 11px;
    color: #999;
  }

  .profile-box {
    display:flex; gap:16px; align-items: center; width:100%; background: var(--color-background); padding:12px; border-radius: 16px; box-sizing: border-box;
  }

  .profile-box > img {
    width:48px;
    height:48px;
    border-radius: 50%;
    object-fit: cover;
    background: gray;
  }

  .profile-box > div {
    display:flex; flex-direction: column; gap:6px;
  }

  .profile-box > div > h2 {
    font-size:20px;
    padding:0;
    margin:0;
  }

  .profile-box > div > span {
    font-size:14px;
  }

  .split-info {
    width:100%;height:100%; display:flex; gap:12px;
  }

  .split-info > div {
    width:100%;height:100%;flex:1; border-radius: 16px; background-color: var(--color-background); display:flex; align-items: center; justify-content: center; flex-direction: column; gap:6px;
  }

  .split-info > div > h2 {
    font-size:20px;
    padding:0;
    margin:0;
  }

  .split-info > div > span {
    font-size:16px;
  }

  /* 찜 버튼 */
  .pick-btn {
    padding: 4px 12px;
    border-radius: 6px;
    border: none;
    background: rgba(255,255,255,0.4);
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
  }

  .pick-btn:hover {
    opacity: 0.8;
  }

  .pick-btn.picked {
    background: rgba(0,0,0,0.4);
  }

  /* 빈 상태 */
  .empty-state {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-muted);
    font-size: 14px;
  }

  /* CSS 추가 */
  .add-btn {
    padding: 6px 12px;
    border-radius: 6px;
    border: none;
    background: transparent;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
  }

  .add-btn:hover {
    opacity: 0.8;
  }

  @media (max-width: 1280px) and (max-height: 800px) {
    .shop-box { 
      padding: 12px !important; 
    }
    ul.list-shop { 
      gap: 12px;
    }
    ul.list-shop > li { 
      width: 100px;
    }
  }

  @media (max-width: 1024px)and(max-height: 768px) {
    small { display: none !important; }

    .header-roulette { 
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
    }

    .header-roulette > h2 {
      font-size:16px;
      color:#fff;
      display:none
    }

    .header-roulette > span {
      font-size:16px;
    }
    
  }

  /* Pagination */
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    padding-top: 4px;
    margin-top: auto;
  }

  .pagination > button {
    border: none;
    border-radius: 6px;
    background:none;
    color: var(--color-text);
    font-size: 13px;
    cursor: pointer;
    transition: all 0.15s;
  }

  .pagination > button:hover:not(:disabled):not(.active) {
    background: var(--color-brand);
    color: #fff;
    opacity: 0.7;
  }

  .pagination > button.active {
    background: var(--color-brand);
    color: #fff;
    font-weight: 700;
  }

  .pagination > button:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  /* #### Portrait 모드 (태블릿/모바일 세로) #### */
  @media (max-width: 1024px) and (orientation: portrait) {
    .new_stack_p1_A {
      grid-template-columns: repeat(4, 1fr) !important;
      grid-template-rows: repeat(6, 1fr) !important;
      --grid-gap: 10px;
    }

    /* 추천 관리고객: 풀너비 2행 */
    .new_stack_p1_A > :nth-child(1) {
      grid-column: 1 / -1 !important;
      grid-row: 1 / 3 !important;
    }

    /* 상담 대기: 좌 2칸 2행 */
    .new_stack_p1_A > :nth-child(2) {
      grid-column: 1 / 3 !important;
      grid-row: 3 / 5 !important;
    }

    /* 룰렛: 우 2칸 2행 */
    .new_stack_p1_A > .roulette {
      grid-column: 3 / -1 !important;
      grid-row: 3 / 5 !important;
      padding-top: 16px !important;
    }

    /* 선물하기: 풀너비 1행 */
    .new_stack_p1_A > .shop-box {
      grid-column: 1 / -1 !important;
      grid-row: 5 / 6 !important;
    }

    /* 버튼 4개: 각 1칸, 맨 하단 — inline col 1/2,2/3,3/4,4/5 그대로 OK */
    .new_stack_p1_A > .box-button {
      grid-row: 6 / 7 !important;
      transform: scale(1) !important;
    }

    /* 텍스트 축소 */
    .header > h2 { font-size: 16px; }
    .header > h2 > small { display: none; }
    .recom-info > h3 { font-size: 13px; }
    .quick-actions { gap: 4px; }
    .qa-btn { padding: 4px 8px; font-size: 11px; }
    .qa-btn > i { font-size: 12px; }
    ul.list-b > li > h2 { font-size: 14px; }
    .box-button > i { font-size: 24px; }
    .box-button > span { font-size: 13px; }
    .box-shape { transform: scale(1) !important; }
  }

</style>